export const ENV = {
  production: !(window.location.hostname === 'localhost')
}



// WEBPACK FOOTER //
// ./src/environment.js